module.exports = __webpack_public_path__ + "img/vicon6.5dc48f01.png";